import axios from 'axios';

import type { FeaturesResponseV2, TeamFeature } from './feature.types';

const featureService = {
  async getAllTeamFeatures(teamId: string) {
    const resp = await axios.get<Array<TeamFeature>>(
      `${window.env.REACT_APP_SINE_CORE_API_ENDPOINT}/feature/${teamId}`,
    );
    return resp.data;
  },

  async getEnabledTeamFeatures(teamId: string) {
    const result = await axios.get<FeaturesResponseV2>(
      `${window.env.REACT_APP_SINE_CORE_API_ENDPOINT}/feature/${teamId}/enabled/v2`,
    );
    return result.data;
  },

  async saveTeamFeature(teamId: string, body: unknown) {
    const { data } = await axios.post(`${window.env.REACT_APP_SINE_CORE_API_ENDPOINT}/feature/${teamId}`, body);
    return data;
  },

  async getTeamFeatures(teamId: string) {
    const resp = await axios.get(`${window.env.REACT_APP_SINE_CORE_API_ENDPOINT}/feature/${teamId}`);
    return resp.data;
  },
};

export default featureService;
